import { Shape } from "three";
import { PathOperationType } from "../flatGeometries";
// Preserves the provided value
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function preserve(i, _max) {
  return i;
}
// Mirrors the values
export function mirror(i, max) {
  return -i + max;
}
// Converts a set of provided paths into a shape
export function convertPathToShape(path, maxSize, transformX, transformY) {
  const shape = new Shape();
  for (let i = 0; i < path.length; i++) {
    const operation = path[i];
    switch (operation.type) {
      case PathOperationType.moveTo:
        shape.moveTo(transformX(operation.x, maxSize.width), transformY(operation.y, maxSize.height));
        break;
      case PathOperationType.lineTo:
        shape.lineTo(transformX(operation.x, maxSize.width), transformY(operation.y, maxSize.height));
        break;
      case PathOperationType.quadraticCurveTo:
        shape.quadraticCurveTo(transformX(operation.aCP1x, maxSize.width), transformY(operation.aCP1y, maxSize.height), transformX(operation.x, maxSize.width), transformY(operation.y, maxSize.height));
        break;
      case PathOperationType.bezierCurveTo:
        shape.bezierCurveTo(transformX(operation.aCP1x, maxSize.width), transformY(operation.aCP1y, maxSize.height), transformX(operation.aCP2x, maxSize.width), transformY(operation.aCP2y, maxSize.height), transformX(operation.x, maxSize.width), transformY(operation.y, maxSize.height));
        break;
      case PathOperationType.arcTo:
        // TODO fully debug transformation of arc points (requires moving x and y by angles)
        shape.absarc(operation.x, operation.y, operation.radius, operation.startAngle, operation.endAngle, false);
        break;
    }
  }
  return shape;
}
// Converts a custom path into a shape including any holes for cutouts
export function convertToShape(customPath, maxSize, primaryTransform, cutoutTransform) {
  // Convert the primary path to a shape
  const shape = convertPathToShape(customPath.primary, maxSize, primaryTransform.x, primaryTransform.y);
  // Add any cutouts as holes to the shape
  if (customPath.cutouts) {
    customPath.cutouts.forEach(path => shape.holes.push(convertPathToShape(path, maxSize, cutoutTransform.x, cutoutTransform.y)));
  }
  return shape;
}